import { useQuery } from "@tanstack/react-query";
import { billingApi } from "../api/billingApi";

export const BILLING_STATUS_KEY = ["assinatura", "status"];

// retry desligado: 503 (assinatura online desligada) é uma resposta definitiva.
export function useBillingStatusQuery() {
  return useQuery({ queryKey: BILLING_STATUS_KEY, queryFn: billingApi.getStatus, retry: false });
}
